import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { trackEvent } from "@/hooks/useAnalytics";

export const CTABand = () => {
  return (
    <section className="py-20 hero-gradient relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-4">
            Start Creating a Tribute That Will Be Cherished for Generations
          </h2>
          <p className="text-xl text-primary-foreground/80 mb-8">
            Your memories deserve a beautiful home.
          </p>
          
          <Button 
            asChild 
            size="lg" 
            className="bg-white text-primary hover:bg-white/90 text-lg px-10 py-6 rounded-full shadow-lg hover:shadow-xl transition-all"
            onClick={() => trackEvent('cta_clicked', { category: 'engagement', label: 'cta_band' })}
          >
            <Link to="/register">
              Start a Tribute Today
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
